var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1049.45 998.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #009640;\n        stroke-miterlimit: 10;\n        stroke-width: 60px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "524.73 97.08 626.8 411.24 957.12 411.24 689.89 605.39 791.96 919.55 524.73 725.39 257.49 919.55 359.57 605.39 92.33 411.24 422.65 411.24 524.73 97.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavN);
export default __webpack_public_path__ + "static/media/fav_n.03f0d0815f42cab070f476992f44d891.svg";
export { ForwardRef as ReactComponent };